import {useEffect} from "react";

export function useGlobalKey(key, callback, enabled = true) {
    useEffect(() => {
        if (!enabled) return;

        const handler = (e) => {
            const swalIsOpen = document.querySelector('.swal2-container');

            if (e.key === key && !swalIsOpen && !e.repeat) {
                e.preventDefault();
                callback(e)
            }
        }

        window.addEventListener("keydown", handler, true);
        return () => window.removeEventListener("keydown", handler, true);

    }, [key, callback, enabled]);
}